"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isError = void 0;
var types_1 = require("./types");
Object.defineProperty(exports, "isError", { enumerable: true, get: function () { return types_1.isError; } });
var errors_1 = require("./errors");
var utils_1 = require("./utils");
var getDownloadLink = function (links) {
    var browser = (0, utils_1.getBrowser)();
    var downloadUrl = (function () {
        if (browser === "Edge")
            return links === null || links === void 0 ? void 0 : links.edge;
        if (browser === "EdgeChromium")
            return (links === null || links === void 0 ? void 0 : links.edge) || (links === null || links === void 0 ? void 0 : links.chrome);
        if (browser === "Chrome")
            return links === null || links === void 0 ? void 0 : links.chrome;
        if (browser === "Firefox")
            return links === null || links === void 0 ? void 0 : links.firefox;
        if (browser === "Opera")
            return links === null || links === void 0 ? void 0 : links.opera;
        if (browser === "Safari")
            return links === null || links === void 0 ? void 0 : links.safari;
        return undefined;
    })();
    return downloadUrl;
};
var Signer = /** @class */ (function () {
    function Signer(_a) {
        var key = _a.key, logs = _a.logs, id = _a.id, onLoadExtension = _a.onLoadExtension, downloadLinks = _a.downloadLinks, requestTimeout = _a.requestTimeout, onRequest = _a.onRequest, onResponse = _a.onResponse, onError = _a.onError;
        this.awaitingExtensionLoad = true;
        this.onLoadExtension = undefined;
        this.onRequest = undefined;
        this.onResponse = undefined;
        this.onError = undefined;
        this.downloadLinks = undefined;
        this.downloadLink = undefined;
        this.id = id;
        this.key = key;
        this.requestTimeout = requestTimeout || 3000;
        this.onLoadExtension = onLoadExtension;
        this.onResponse = onResponse;
        this.onRequest = onRequest;
        this.onError = onError;
        this.logs = logs || false;
        this.downloadLinks = downloadLinks;
        this.downloadLink = getDownloadLink(downloadLinks);
        this.extensionLoadMonitor();
    }
    Signer.prototype.getError = function (code) {
        var error = (0, errors_1.getLibError)(code);
        if (this.onError)
            this.onError(error);
        return error;
    };
    Signer.prototype.log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.logs) {
            console.log.apply(console, __spreadArray(["[extension lib] " + new Date().toLocaleString(), message], optionalParams, false));
        }
    };
    // It takes ~250 ms when activated
    Signer.prototype.extensionLoadMonitor = function () {
        var _this = this;
        this.log("Monitoring extension load!");
        var interval = setInterval(function () {
            var _a;
            var hasSigner = typeof window !== "undefined" &&
                document &&
                ((_a = document
                    .querySelector("body")) === null || _a === void 0 ? void 0 : _a.classList.contains("extension-" + _this.id.toLowerCase() + "-activated"));
            if (hasSigner) {
                _this.awaitingExtensionLoad = false;
                _this.log("Extension loaded!");
                if (_this.onLoadExtension)
                    _this.onLoadExtension();
                clearInterval(interval);
            }
        }, 10);
    };
    Signer.prototype.sendMessage = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var timestamp, request;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.awaitingExtensionLoad) return [3 /*break*/, 2];
                        return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, 100); })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2:
                        timestamp = +new Date() + "-" + Math.random();
                        request = {
                            type: "REQUEST",
                            key: this.key,
                            id: this.id,
                            data: data,
                            timestamp: timestamp,
                            logs: this.logs,
                        };
                        if (this.onRequest)
                            this.onRequest(request);
                        window.postMessage(request, "*");
                        this.log(request);
                        return [2 /*return*/, new Promise(function (resolve) {
                                var listener = function (event) {
                                    var eventData = event.data;
                                    var type = eventData.type;
                                    var isReponse = type === "RESPONSE";
                                    var sameTime = eventData.timestamp === timestamp;
                                    var sameID = eventData.operation === data.operation;
                                    if (isReponse && sameTime && sameID) {
                                        var response = eventData.response;
                                        _this.log(eventData);
                                        if (_this.onResponse)
                                            _this.onResponse(response, request);
                                        if (_this.onError && _this.isError(response))
                                            _this.onError(response);
                                        resolve(response);
                                        window.removeEventListener("message", listener, false);
                                    }
                                };
                                window.addEventListener("message", listener, false);
                            })];
                }
            });
        });
    };
    Signer.prototype.hasExtension = function () {
        return __awaiter(this, void 0, void 0, function () {
            var hasExtensRes, dontHasExten, hasExt, extVersions, maximiumVersion, minimiumVersion, extensionVersion, softwareDownloadUrl;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log("hasExtension finding");
                        hasExtensRes = this.sendMessage({ operation: "extension" });
                        dontHasExten = new Promise(function (resolve) {
                            return setTimeout(function () {
                                if (!_this.downloadLink)
                                    return resolve('BROWSER_DOWNLOAD_URL_NOT_FOUND');
                                return resolve(false);
                            }, _this.requestTimeout);
                        });
                        return [4 /*yield*/, Promise.race([hasExtensRes, dontHasExten])];
                    case 1:
                        hasExt = _a.sent();
                        if (hasExt === false) {
                            this.log("hasExtension timeout");
                            return [2 /*return*/, this.getError(1)];
                        }
                        if (hasExt === 'BROWSER_DOWNLOAD_URL_NOT_FOUND')
                            return [2 /*return*/, this.getError(4)];
                        this.log("hasExtension found");
                        extVersions = hasExt;
                        maximiumVersion = extVersions.maximiumVersion, minimiumVersion = extVersions.minimiumVersion, extensionVersion = extVersions.extensionVersion, softwareDownloadUrl = extVersions.softwareDownloadUrl;
                        this.maximiumSoftwareVersion = maximiumVersion;
                        this.minimiumSoftwareVersion = minimiumVersion;
                        this.extensionVersion = extensionVersion;
                        this.softwareDownloadUrl = softwareDownloadUrl;
                        return [2 /*return*/, true];
                }
            });
        });
    };
    Signer.prototype.hasSoftware = function () {
        return __awaiter(this, void 0, void 0, function () {
            var hasExt, hasSoftwaRes, cliRes, softVersion;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.hasExtension()];
                    case 1:
                        hasExt = _a.sent();
                        if (hasExt !== true)
                            return [2 /*return*/, hasExt]; // Error
                        this.log("hasSoftware finding");
                        return [4 /*yield*/, this.sendMessage({ operation: "version" })];
                    case 2:
                        hasSoftwaRes = _a.sent();
                        if ((0, types_1.isError)(hasSoftwaRes)) {
                            this.log("hasSoftware not found");
                            return [2 /*return*/, hasSoftwaRes];
                        }
                        this.log("hasSoftware found");
                        cliRes = hasSoftwaRes;
                        softVersion = cliRes.message;
                        this.softwareVersion = softVersion.version;
                        return [2 /*return*/, true];
                }
            });
        });
    };
    Signer.prototype.sign = function (_a) {
        var dataToSignArray = _a.dataToSignArray, certificate = _a.certificate;
        return __awaiter(this, void 0, void 0, function () {
            var hasExt, hasSoft, algorithm, cert, jsonData, signResponse, cliRes, signatureArray;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!dataToSignArray)
                            return [2 /*return*/, this.getError(2)];
                        if (!certificate)
                            return [2 /*return*/, this.getError(3)];
                        return [4 /*yield*/, this.hasExtension()];
                    case 1:
                        hasExt = _b.sent();
                        if (hasExt !== true)
                            return [2 /*return*/, hasExt];
                        return [4 /*yield*/, this.hasSoftware()];
                    case 2:
                        hasSoft = _b.sent();
                        if (hasSoft !== true)
                            return [2 /*return*/, hasSoft];
                        algorithm = "SHA256";
                        cert = certificate;
                        jsonData = __assign({ dataToSignArray: dataToSignArray, algorithm: algorithm, provider: cert.provider, 
                            // password: "1234" || '',
                            specialName: cert.specialName, host: window.location.protocol + "//" + window.location.host }, (cert.path ? { path: cert.path } : {}));
                        return [4 /*yield*/, this.sendMessage(__assign({ operation: "signbatch" }, jsonData))];
                    case 3:
                        signResponse = _b.sent();
                        if ((0, types_1.isError)(signResponse))
                            return [2 /*return*/, signResponse];
                        cliRes = signResponse;
                        signatureArray = (cliRes === null || cliRes === void 0 ? void 0 : cliRes.message) || [];
                        return [2 /*return*/, signatureArray];
                }
            });
        });
    };
    Signer.prototype.getCertificates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var hasSoft, searchResponse, cliRes, list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.hasSoftware()];
                    case 1:
                        hasSoft = _a.sent();
                        if (hasSoft !== true)
                            return [2 /*return*/, hasSoft];
                        return [4 /*yield*/, this.sendMessage({ operation: "search" })];
                    case 2:
                        searchResponse = _a.sent();
                        if ((0, types_1.isError)(searchResponse))
                            return [2 /*return*/, searchResponse];
                        cliRes = searchResponse;
                        list = (cliRes === null || cliRes === void 0 ? void 0 : cliRes.message) || [];
                        return [2 /*return*/, list];
                }
            });
        });
    };
    Signer.prototype.downloadExtension = function (_a) {
        var _b = _a === void 0 ? {
            openUrl: true,
        } : _a, openUrl = _b.openUrl;
        if (!this.downloadLinks)
            return this.getError(6);
        var downloadUrl = this.downloadLink;
        this.log("downloadExtension", { downloadUrl: downloadUrl });
        if (downloadUrl) {
            if (openUrl)
                window.open(downloadUrl);
            return downloadUrl;
        }
        return this.getError(4);
    };
    Signer.prototype.downloadSoftware = function (_a) {
        var _b = _a === void 0 ? {
            openUrl: true,
        } : _a, openUrl = _b.openUrl;
        return __awaiter(this, void 0, void 0, function () {
            var hasExt, downloadUrl;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.hasExtension()];
                    case 1:
                        hasExt = _c.sent();
                        if (hasExt !== true)
                            return [2 /*return*/, hasExt];
                        if (this.isError(hasExt))
                            return [2 /*return*/, hasExt];
                        downloadUrl = this.softwareDownloadUrl;
                        this.log("downloadSoftware", { downloadUrl: downloadUrl });
                        if (!downloadUrl)
                            return [2 /*return*/, this.getError(5)];
                        if (openUrl)
                            window.open(downloadUrl);
                        return [2 /*return*/, downloadUrl];
                }
            });
        });
    };
    Signer.prototype.isError = function (res) {
        return res.error !== undefined;
    };
    return Signer;
}());
exports.default = Signer;
